// src/contexts/ServerStatusContext.js
import { createContext, useContext, useState, useEffect } from 'react';

const ServerStatusContext = createContext();

export const useServerStatus = () => useContext(ServerStatusContext);

export const ServerStatusProvider = ({ children }) => {
    const [mainLobby, setMainLobby] = useState({
        online: false,
        players: 0,
        maxPlayers: 400
    });

    const [gameModes, setGameModes] = useState({
        main: { online: false, players: 0, max: 400, name: "لابی اصلی" },
        roleplay: { online: false, players: 0, max: 100, name: "رول‌پلی" },
        bedwars: { online: false, players: 0, max: 500, name: "بدوارز" },
        pillars: { online: false, players: 0, max: 200, name: "پیلارز" },
        arcade: { online: false, players: 0, max: 100, name: "ارکید" },
        skyblock: { online: false, players: 0, max: 100, name: "اسکای‌بلاک" }
    });

    const [lastUpdate, setLastUpdate] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchAllStatus = async () => {
        try {
            setLoading(true);
            const res = await fetch('/api/minecraft/all');
            // اگه پراکسی نداری: http://localhost:5000/api/minecraft/all

            if (!res.ok) throw new Error('خطا در دریافت وضعیت');

            const data = await res.json();
            setLastUpdate(data.updatedAt);

            // فقط لابی اصلی (برای هوم‌پیج)
            setMainLobby({
                online: data.main.online,
                players: data.main.players,
                maxPlayers: data.main.max
            });

            // همه گیم‌مودها
            setGameModes({
                main: { ...data.main, max: data.main.max || 400 },
                roleplay: { ...data.roleplay, max: 100 },
                bedwars: { ...data.bedwars, max: 500 },
                pillars: { ...data.pillars, max: 200 },
                arcade: { ...data.arcade, max: 100 },
                skyblock: { ...data.skyblock, max: 100 }
            });

        } catch (err) {
            console.log("خطا در دریافت وضعیت سرورها:", err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllStatus();
        const interval = setInterval(fetchAllStatus, 25000); // هر ۲۵ ثانیه آپدیت شه
        return () => clearInterval(interval);
    }, []);

    return (
        <ServerStatusContext.Provider value={{
            mainLobby,
            gameModes,
            lastUpdate,
            loading,
            refetch: fetchAllStatus
        }}>
            {children}
        </ServerStatusContext.Provider>
    );
};